function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewPaused = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 187",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.745 15.784h.975v-5.168h-.975zm2.535 0h.975v-5.168h-.975zM4.975 18.4A1 1 0 0 1 4 17.425v-8.45A1 1 0 0 1 4.975 8h11.05a1 1 0 0 1 .975.975v8.45a1 1 0 0 1-.975.975zm0-.975h11.05v-8.45H4.975zm0 0z",
    transform: "translate(-2.5 -5.2)",
    style: {
      fill: "#f59064"
    }
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewPaused, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/newPaused.a0a9f204.svg";
export { ForwardRef as ReactComponent };